import React from "react";
import { PlusIcon } from "@heroicons/react/24/outline";
import Capabilities from "./Capabilities";
import {
  ADDITIONAL_SCOPE_CHIP_CLASS,
  ADDITIONAL_SCOPE_DIVIDER_CLASS,
  parseDelimitedScopeTags,
} from "../utils/scopeDisplayUtils";

/**
 * Renders predefined service category badges, optional divider, and Additional Scope chips.
 * Matches the Assessment Details Scope row pattern (US 13961).
 *
 * `addedScope`/`addedScopeTags` are optional: only a join sub-request row ever
 * has pending/confirmed per-sponsor scope add-ons, so the originator row (and every
 * pre-existing caller that doesn't pass these props) renders exactly as before.
 */
const ScopeWithAdditionalTags = ({
  services,
  additionalScope,
  showAdditionalScope = true,
  capabilitiesProps = {},
  addedScope,
  addedScopeTags,
}) => {
  const tags =
    showAdditionalScope && Array.isArray(additionalScope)
      ? additionalScope.filter(Boolean)
      : [];
  const hasTags = tags.length > 0;

  const addedServices = Array.isArray(addedScope)
    ? addedScope.filter(Boolean)
    : [];
  const addedTags = parseDelimitedScopeTags(addedScopeTags);
  const hasAdded = addedServices.length > 0 || addedTags.length > 0;

  return (
    <div className="flex flex-wrap items-center gap-2">
      <Capabilities services={services || []} {...capabilitiesProps} />
      {hasTags && (
        <>
          <div className={ADDITIONAL_SCOPE_DIVIDER_CLASS} />
          {tags.map((tag, index) => (
            <span key={`${tag}-${index}`} className={ADDITIONAL_SCOPE_CHIP_CLASS}>
              {tag}
            </span>
          ))}
        </>
      )}
      {hasAdded && (
        <>
          <div className={ADDITIONAL_SCOPE_DIVIDER_CLASS} />
          <span className="inline-flex items-center gap-1 text-xs font-medium text-gray-500">
            <PlusIcon className="h-3.5 w-3.5" aria-hidden="true" />
            Added
          </span>
          {addedServices.length > 0 && (
            <Capabilities
              services={addedServices}
              icon={capabilitiesProps.icon}
            />
          )}
          {addedTags.map((tag, index) => (
            <span
              key={`added-tag-${tag}-${index}`}
              className={ADDITIONAL_SCOPE_CHIP_CLASS}
            >
              {tag}
            </span>
          ))}
        </>
      )}
    </div>
  );
};

export default ScopeWithAdditionalTags;
